import React from 'react';
import ImageN from '@gerenciatd/next.components.image-n';
import TextInfo from '@gerenciatd/next.components.text-info-n';
import Button from '@gerenciatd/next.components.button-n';


const TvSlide = (props) => {
  const { layout, bgImage, minHeight, custoObjectInfo } = props;

  let imagenCustoObjectInfo1 = null;
  let imagenCustoObjectInfo2 = null;
  let imagenCustoObjectInfo3 = null;
  let textInfoCustoObjectInfo1 = null;
  let textInfoCustoObjectInfo2 = null;
  let textInfoCustoObjectInfo3 = null; 
  let buttonCustoObjectInfo1 = null;
  if (custoObjectInfo) {
    imagenCustoObjectInfo1 = custoObjectInfo.addEntryPoint({
      custoObjectInfo,
      entryPoint: 'Image-1',
    })
    imagenCustoObjectInfo2 = custoObjectInfo.addEntryPoint({
      custoObjectInfo,
      entryPoint: 'Image-2',
    })
    imagenCustoObjectInfo3 = custoObjectInfo.addEntryPoint({
      custoObjectInfo,
      entryPoint: 'Image-3',
    })
    textInfoCustoObjectInfo1 = custoObjectInfo.addEntryPoint({
      custoObjectInfo,
      entryPoint: 'TextInfo-1',
    });
    textInfoCustoObjectInfo2 = custoObjectInfo.addEntryPoint({
      custoObjectInfo,
      entryPoint: 'TextInfo-2',
    });
    textInfoCustoObjectInfo3 = custoObjectInfo.addEntryPoint({
      custoObjectInfo,
      entryPoint: 'TextInfo-3',
    });
    buttonCustoObjectInfo1 = custoObjectInfo.addEntryPoint({
      custoObjectInfo,
      entryPoint: 'Button-1',
    });
  }

 
  return (
    <>
      <div className="TVSlide" style={{ minHeight: `${minHeight}px` }}>
        <div className='desktop-bg-slide'>
          <ImageN
            {...props['Image-1']}
            objectFit="cover"
            custoObjectInfo={imagenCustoObjectInfo1}
          />
        </div>
        <div className='tablet-bg-slide'>
          <ImageN
            {...props['Image-2']}
            objectFit="cover"
            custoObjectInfo={imagenCustoObjectInfo2}
          />
        </div>
        <div className='mobile-bg-slide'>
          <ImageN
            {...props['Image-3']}
            objectFit="cover"
            custoObjectInfo={imagenCustoObjectInfo3}
          />
        </div>
        <div className={`tv-info-content ${layout}`}>
          {props && props['TextInfo-1'] && (
            <TextInfo {...props['TextInfo-1']} custoObjectInfo={textInfoCustoObjectInfo1} />
          )}
          {props && props['TextInfo-2'] && (
            <TextInfo {...props['TextInfo-2']} custoObjectInfo={textInfoCustoObjectInfo2} />
          )}
          {props && props['TextInfo-3'] && (
            <div className="TextInfo-3">
              <TextInfo {...props['TextInfo-3']} custoObjectInfo={textInfoCustoObjectInfo3} />
            </div>
          )}        
          {props && props['Button-1'] && (
            <Button {...props['Button-1']} custoObjectInfo={buttonCustoObjectInfo1}  />
          )}
        </div>
      </div>
        <style jsx>
          {`
            .TVSlide {
              position:absolute;
              top:0px;
              left:0px;
              width:100%;
              height: 100%;
              min-height: 400px;
              border-radius: 1.25rem;
              overflow:hidden;
              grid-template-columns: repeat(3, 1fr); 
              .TextInfo-3{
                line-height:2rem;
              }
              .desktop-bg-slide { display:block }
              .tablet-bg-slide { display: none;}
              .mobile-bg-slide {display: none;} 
              .tv-info-content{
                position:absolute;
                top: 50%;
                right:1rem;
                width:100%;
                max-width: 18rem;
                padding: 1rem;
                transform:translate(0px, -50%);
                display: grid;
                grid-auto-rows: max-content;
                gap: 1rem;
                border-radius: 0.75rem;
                background-color: var(--color-gp--blue)
              }
            }
            @media screen and (max-width:1224px) {
              .TVSlide{
                .desktop-bg-slide { display:none }
                .tablet-bg-slide { display:block }
                .mobile-bg-slide { display:none; }
              }
            }

            @media screen and (max-width:768px) {
              .TVSlide{
                .desktop-bg-slide { display:none }
                .tablet-bg-slide { display:none }
                .mobile-bg-slide { display:block; }
              }
            }


          `}
        </style>
    </>
  )
}

export default TvSlide;